import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt,
    faPhone,
    faEnvelope,
    faClock,
    faCode
} from '@fortawesome/free-solid-svg-icons';
import {
    faInstagram
} from '@fortawesome/free-brands-svg-icons';
import smallLogo from '../../../assets/images/small-logo.svg';
import { trackCallClick } from '../../../utils/tracking';
import './Footer.css';

const Footer = ({ theme = 'default' }) => {
    const currentYear = new Date().getFullYear();

    // Function to scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className={`footer footer-${theme}`}>
            <div className="footer-top">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-logo-col">
                            <Link to="/" className="footer-logo-link" onClick={scrollToTop}>
                                <div className="logo-container">
                                    <img src={smallLogo} alt="Abhyaas Logo" className="footer-logo" />
                                </div>
                            </Link>
                            <p className="footer-tagline">
                                Nurturing young minds with quality education and creative learning experiences.
                            </p>
                            <div className="footer-social">
                                <a href="https://www.instagram.com/littleellykudlu" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                            </div>
                        </div>

                        <div className="footer-links-col">
                            <h4 className="footer-heading">Quick Links</h4>
                            <ul className="footer-links">
                                <li>
                                    <Link to="/" onClick={scrollToTop}>
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/about" onClick={scrollToTop}>
                                        About Us
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/schools/little-elly-kudlu" onClick={scrollToTop}>
                                        Little Elly Kudlu
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/summer-camp" onClick={scrollToTop}>
                                        Summer Camp
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="footer-contact-col">
                            <h4 className="footer-heading">Contact Us</h4>
                            <ul className="footer-contact">
                                <li>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                    <span>Little Elly Campus, Kudlu Main Road, Bengaluru, Karnataka 560068</span>
                                </li>
                                <li>
                                    <FontAwesomeIcon icon={faPhone} />
                                    <span><a href="tel:+919019829264" onClick={() => trackCallClick({ location: 'footer' })}>+91 90198 29264</a> | <a href="tel:+917899393198" onClick={() => trackCallClick({ location: 'footer' })}>+91 78993 93198</a></span>
                                </li>
                                <li>
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <span><a href="mailto:abhyaas@littleelly.com">abhyaas@littleelly.com</a></span>
                                </li>
                                <li>
                                    <FontAwesomeIcon icon={faClock} />
                                    <span>Mon - Sat: 9:00 AM - 4:00 PM</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-content">
                        <div className="footer-copyright-wrapper">
                            <p className="footer-copyright">
                                © {currentYear} Abhyaas Educational Trust. All rights reserved.
                            </p>
                            <p className="footer-credit">
                                <FontAwesomeIcon icon={faCode} className="code-icon"/> Website crafted by <a
                                href="https://neuralway.ai" target="_blank" rel="noopener noreferrer"
                                className="neuralway-link">neuralway.ai</a>
                            </p>
                        </div>
                        <div className="footer-bottom-links">
                            <Link
                                to="/privacy-policy"
                                onClick={scrollToTop}
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                to="/terms-of-use"
                                onClick={scrollToTop}
                            >
                                Terms of Use
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;